import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMore = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgMore" data-sentry-source-file="more.tsx">
    <g clipPath="url(#more_svg__a)" data-sentry-element="g" data-sentry-source-file="more.tsx">
      <path fill="#263E6A" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" data-sentry-element="path" data-sentry-source-file="more.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="more.tsx">
      <clipPath id="more_svg__a" data-sentry-element="clipPath" data-sentry-source-file="more.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="more.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgMore;